import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faFile } from "@fortawesome/pro-regular-svg-icons/faFile";
import { faFileAlt } from "@fortawesome/pro-regular-svg-icons/faFileAlt";
import { faFileArchive } from "@fortawesome/pro-regular-svg-icons/faFileArchive";
import { faFileAudio } from "@fortawesome/pro-regular-svg-icons/faFileAudio";
import { faFileExcel } from "@fortawesome/pro-regular-svg-icons/faFileExcel";
import { faFileImage } from "@fortawesome/pro-regular-svg-icons/faFileImage";
import { faFilePdf } from "@fortawesome/pro-regular-svg-icons/faFilePdf";
import { faFilePowerpoint } from "@fortawesome/pro-regular-svg-icons/faFilePowerpoint";
import { faFileVideo } from "@fortawesome/pro-regular-svg-icons/faFileVideo";
import { faFileWord } from "@fortawesome/pro-regular-svg-icons/faFileWord";

interface IIcon {
    readonly icon: IconDefinition;
    readonly pattern: RegExp;
}

export const DEFAULT_ICON = faFile;

export const ICONS: IIcon[] = [
    { icon: faFileImage, pattern: /jpe?g|png|gif|bmp|webp/i },
    { icon: faFileArchive, pattern: /zip|tar/i },
    { icon: faFileVideo, pattern: /avi|wmv|flv|mpg|mp4|mov|mpeg/i },
    { icon: faFileAudio, pattern: /wav|mp3|ogg|wma|flac/ },
    { icon: faFilePdf, pattern: /pdf/i },
    { icon: faFileAlt, pattern: /txt/i },
    { icon: faFileWord, pattern: /docx?/i },
    { icon: faFileExcel, pattern: /xlsx?/i },
    { icon: faFilePowerpoint, pattern: /pptx?/i },
];
